/**
 * Mock SFTP Service
 *
 * In-memory mock that mirrors the real sftpService API.
 * Used when VITE_ENABLE_MOCK_DATA=true.
 */

import { mockSftpSites } from '../data/mockData';

let sites = JSON.parse(JSON.stringify(mockSftpSites));
let nextId = 100;

const delay = (ms = 200) => new Promise(r => setTimeout(r, ms));

export const getSftpSites = async (params = {}) => {
  await delay();
  const { search = '', page = 1, limit = 10 } = params;

  let filtered = sites;
  if (search) {
    const term = search.toLowerCase();
    filtered = filtered.filter(s =>
      s.name.toLowerCase().includes(term) ||
      (s.description && s.description.toLowerCase().includes(term))
    );
  }

  const total = filtered.length;
  const totalPages = Math.ceil(total / limit) || 1;
  const start = (page - 1) * limit;
  const data = filtered.slice(start, start + limit);

  return { data, pagination: { page, limit, total, totalPages } };
};

export const getAllSftpSites = async () => {
  await delay();
  return sites.filter(s => s.isActive);
};

export const getSftpSiteById = async (siteId) => {
  await delay();
  const site = sites.find(s => s.id === siteId);
  if (!site) throw new Error('SFTP site not found');
  return {
    ...site,
    connection: {
      host: 'sftp.example.com',
      port: 22,
      username: 'demo-user',
      remotePath: '/incoming/reports',
      authMethod: 'password',
      hasCredentials: true,
      hasPassphrase: false,
      hostKeyFingerprint: '',
      timeout: 30,
      notes: ''
    }
  };
};

export const createSftpSite = async (siteData) => {
  await delay(300);
  const newSite = {
    id: nextId++,
    name: siteData.name,
    description: siteData.description || '',
    awsSecretName: siteData.name.toLowerCase().replace(/\s+/g, '-'),
    isActive: true,
    reportCount: 0
  };
  sites.push(newSite);
  return { data: newSite };
};

export const updateSftpSite = async (siteId, siteData) => {
  await delay(300);
  const site = sites.find(s => s.id === siteId);
  if (!site) throw new Error('SFTP site not found');
  if (siteData.name !== undefined) site.name = siteData.name;
  if (siteData.description !== undefined) site.description = siteData.description;
  return { data: { id: siteId } };
};

export const deleteSftpSite = async (siteId) => {
  await delay(300);
  const site = sites.find(s => s.id === siteId);
  if (!site) throw new Error('SFTP site not found');
  if (site.reportCount > 0) throw new Error('Cannot delete: site is in use by reports');
  sites = sites.filter(s => s.id !== siteId);
  return { success: true };
};

export const browseSftpFiles = async (siteId) => {
  await delay(500);
  const site = sites.find(s => s.id === siteId);
  if (!site) throw new Error('SFTP site not found');
  return {
    siteName: site.name,
    path: '/home/sftptest/uploads',
    files: [
      { name: 'report_2026-03-01.pdf', size: 245000, modified: '2026-03-01T10:30:00Z', isDirectory: false },
      { name: 'report_2026-03-10.pdf', size: 312000, modified: '2026-03-10T14:15:00Z', isDirectory: false },
      { name: 'archive', size: 0, modified: '2026-02-15T09:00:00Z', isDirectory: true }
    ],
    total: 3
  };
};
